<script>
	import { createEventDispatcher } from 'svelte';
	import Icon from '../icons/Icon.svelte';

	const dispatch = createEventDispatcher();

	export let show = false;
	export let editingProductId = null;
	export let productForm = {};
	export let productFormErrors = { category: false, name: false, price: false };
	export let categories = [];
	export let complementGroups = [];
	export let globalGroupIdsPending = [];
	export let catalogOriginInfo = null;
	export let pizzaSizesDiffText = '';
	export let isSavingProduct = false;

	function handleClose() {
		dispatch('close');
	}

	function handleSave() {
		dispatch('save');
	}

	function handleImageUpload(e) {
		dispatch('imageUpload', e);
	}

	function handleRemoveImage() {
		dispatch('removeImage');
	}

	function handleOpenMasterCatalog() {
		dispatch('openMasterCatalog');
	}

	function handleClearOrigin() {
		dispatch('clearOrigin');
	}

	function handleToggleGlobalGroup(groupId) {
		dispatch('toggleGlobalGroup', groupId);
	}

	function handleStepPrice(field, delta) {
		dispatch('stepPrice', { field, delta });
	}

	function handlePriceInput(e, field) {
		dispatch('priceInput', { e, field });
	}

	function handlePriceBlur(field) {
		dispatch('priceBlur', field);
	}

	function handlePizzaSizesToggle() {
		dispatch('pizzaSizesToggle');
	}

	function handlePizzaPriceInput(e, type) {
		dispatch('pizzaPriceInput', { e, type });
	}

	function handlePizzaPriceBlur(type) {
		dispatch('pizzaPriceBlur', type);
	}
</script>

{#if show}
	<div class="modal-overlay" on:click={handleClose}>
		<div class="modal-box modal-large" on:click|stopPropagation>
			<div class="modal-header">
				<div class="modal-title-group">
					<span class="modal-badge-icon"><Icon name="package" size={16} color="#FF6A00" /></span>
					<h3>{editingProductId ? "Editar Produto" : "Novo Produto no Cardápio"}</h3>
				</div>
				<button type="button" class="close-btn" on:click={handleClose} aria-label="Fechar">
					<Icon name="x" size={16} />
				</button>
			</div>

			<div class="modal-body modal-scroll">
				<!-- Acelerador: Catálogo Mestre de Produtos -->
				<div class="catalog-master-trigger-card">
					<div class="catalog-trigger-left">
						<div class="catalog-trigger-icon" aria-hidden="true">
							<Icon name="book-open" size={20} color="#FF6A00" />
						</div>
						<div class="catalog-trigger-text">
							<strong>Comece mais rápido pelo Catálogo Mestre</strong>
							<span>536 itens com fotos profissionais, marcas e sugestões de atacado</span>
						</div>
					</div>
					<button
						type="button"
						class="btn-open-catalog-master"
						on:click={handleOpenMasterCatalog}
					>
						<Icon name="search" size={14} color="#FFFFFF" />
						<span>Buscar no Catálogo</span>
					</button>
				</div>

				{#if catalogOriginInfo}
					<div class="catalog-prefilled-badge">
						<div class="badge-content">
							<Icon name="check" size={14} color="#059669" />
							<span>
								Pré-preenchido do Catálogo Mestre
								{#if catalogOriginInfo.brand} · <strong>{catalogOriginInfo.brand}</strong>{/if}
								{#if catalogOriginInfo.suggestedPrice} · Ref: {Number(catalogOriginInfo.suggestedPrice).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}{/if}
							</span>
						</div>
						<button type="button" class="btn-clear-origin" on:click={handleClearOrigin} title="Remover aviso" aria-label="Remover aviso">
							<Icon name="x" size={12} />
						</button>
					</div>
				{/if}

				<!-- Seção de Foto do Item -->
				<div class="form-row photo-upload-block">
					<span class="field-label">Foto do Prato / Item (Obrigatória para o Cardápio & WhatsApp)</span>
					<div class="product-photo-card">
						{#if productForm.image}
							<div class="prod-full-preview-box">
								<img src={productForm.image} alt="Foto do Produto" class="prod-full-preview-img" />
								<div class="prod-preview-controls">
									<button type="button" class="btn-overlay-bank" on:click={handleOpenMasterCatalog} title="Trocar por foto do Catálogo Mestre">
										<Icon name="book-open" size={13} color="#FFFFFF" />
										<span>Catálogo Mestre</span>
									</button>
									<label class="btn-overlay-change">
										<Icon name="camera" size={13} />
										<span>Trocar Foto</span>
										<input type="file" accept="image/*" style="display:none;" on:change={handleImageUpload} />
									</label>
									<button type="button" class="btn-overlay-remove" on:click={handleRemoveImage}>
										Remover
									</button>
								</div>
							</div>
						{:else}
							<label class="product-photo-dropzone">
								<input type="file" accept="image/*" style="display:none;" on:change={handleImageUpload} />
								<div class="dropzone-svg-box">
									<Icon name="camera" size={28} color="#FF6A00" />
								</div>
								<strong>Clique ou arraste para enviar foto do seu computador</strong>
								<small>PNG, JPG ou WEBP até 8MB (Fotos reais aumentam as vendas)</small>
							</label>

							<div class="photo-catalog-alt-row">
								<button type="button" class="btn-search-catalog-photo" on:click={handleOpenMasterCatalog}>
									<Icon name="book-open" size={14} color="#FF6A00" />
									<span>Ou escolha uma foto oficial do Catálogo Mestre</span>
								</button>
							</div>

							<div class="fallback-url-row">
								<span>Ou informe a URL da foto:</span>
								<input type="text" placeholder="https://exemplo.com/foto.jpg..." bind:value={productForm.image} />
							</div>
						{/if}
					</div>
				</div>

				<div class="form-grid-2">
					<div class="form-row">
						<label class="field-label" for="product-form-category">Categoria do Produto *</label>
						<select 
							id="product-form-category"
							class="form-input" 
							class:input-error={productFormErrors.category}
							bind:value={productForm.categoryId}
							on:change={() => { productFormErrors.category = false; }}
						>
							{#each categories as cat}
								<option value={cat.id}>{cat.name}</option>
							{/each}
						</select>
						{#if productFormErrors.category}
							<span class="field-error-hint">Selecione uma categoria</span>
						{/if}
					</div>

					<div class="form-row">
						<label class="field-label" for="product-form-name">Nome do Produto *</label>
						<input 
							id="product-form-name"
							type="text" 
							class="form-input" 
							class:input-error={productFormErrors.name}
							placeholder="Ex: Smash Bacon Duplo" 
							bind:value={productForm.name} 
							on:input={() => { productFormErrors.name = false; }}
						/>
						{#if productFormErrors.name}
							<span class="field-error-hint">Informe o nome do produto</span>
						{/if}
					</div>
				</div>

				<div class="form-grid-2">
					<div class="form-row">
						<label class="field-label" for="product-form-price">
							Preço Base (R$) *
							{#if productForm.pizzaSizesEnabled}
								<span class="badge-auto-calc">(Definido pela Broto)</span>
							{/if}
						</label>
						<div class="price-input-wrapper-modal">
							<span class="currency-tag">R$</span>
							<input 
								id="product-form-price"
								type="text" 
								inputmode="decimal"
								class="form-input modal-price-input" 
								class:input-error={productFormErrors.price}
								placeholder="0,00" 
								disabled={productForm.pizzaSizesEnabled}
								value={productForm.price} 
								on:input={(e) => { productFormErrors.price = false; handlePriceInput(e, 'price'); }}
								on:blur={() => handlePriceBlur('price')}
							/>
							{#if !productForm.pizzaSizesEnabled}
								<div class="stepper-buttons-group">
									<button type="button" class="btn-step" on:click={() => handleStepPrice('price', 1)} title="Aumentar R$ 1,00">
										<svg width="8" height="5" viewBox="0 0 10 6" fill="currentColor"><path d="M5 0L10 6H0L5 0Z"/></svg>
									</button>
									<button type="button" class="btn-step" on:click={() => handleStepPrice('price', -1)} title="Diminuir R$ 1,00">
										<svg width="8" height="5" viewBox="0 0 10 6" fill="currentColor"><path d="M5 6L0 0H10L5 6Z"/></svg>
									</button>
								</div>
							{/if}
						</div>
						{#if productFormErrors.price}
							<span class="field-error-hint">Informe um preço válido maior que zero</span>
						{/if}
					</div>

					<div class="form-row">
						<label class="field-label" for="product-form-promo-price">Preço Promocional (Opcional)</label>
						<div class="price-input-wrapper-modal">
							<span class="currency-tag">R$</span>
							<input 
								id="product-form-promo-price"
								type="text" 
								inputmode="decimal"
								class="form-input modal-price-input" 
								placeholder="Deixe em branco se não houver promoção" 
								value={productForm.promoPrice} 
								on:input={(e) => handlePriceInput(e, 'promoPrice')}
								on:blur={() => handlePriceBlur('promoPrice')}
							/>
							<div class="stepper-buttons-group">
								<button type="button" class="btn-step" on:click={() => handleStepPrice('promoPrice', 1)} title="Aumentar R$ 1,00">
									<svg width="8" height="5" viewBox="0 0 10 6" fill="currentColor"><path d="M5 0L10 6H0L5 0Z"/></svg>
								</button>
								<button type="button" class="btn-step" on:click={() => handleStepPrice('promoPrice', -1)} title="Diminuir R$ 1,00">
									<svg width="8" height="5" viewBox="0 0 10 6" fill="currentColor"><path d="M5 6L0 0H10L5 6Z"/></svg>
								</button>
							</div>
						</div>
					</div>
				</div>

				<!-- Seção: Tamanhos da Pizza (Broto e Grande com Preços Individuais) -->
				<div class="pizza-sizes-config-box">
					<div class="pizza-sizes-toggle-row">
						<div class="pizza-sizes-toggle-meta">
							<div class="pizza-sizes-toggle-title">
								<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#EA580C" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
									<circle cx="12" cy="12" r="10"></circle>
									<path d="M12 2a10 10 0 0 1 10 10"></path>
								</svg>
								<span class="pizza-title-text">Pizza com Variações de Tamanho</span>
								<span class="badge-pizza-sizes">Broto & Grande</span>
							</div>
							<p class="pizza-sizes-toggle-desc">Ative para definir preços individuais para Broto (4 fatias) e Grande (8 fatias).</p>
						</div>
						<label class="switch-control" for="product-pizza-sizes-switch" title="Ativar tamanhos Broto e Grande">
							<input
								id="product-pizza-sizes-switch"
								type="checkbox"
								bind:checked={productForm.pizzaSizesEnabled}
								on:change={handlePizzaSizesToggle}
							/>
							<span class="slider-switch"></span>
						</label>
					</div>

					{#if productForm.pizzaSizesEnabled}
						<div class="pizza-sizes-inputs-grid">
							<div class="form-row">
								<label class="field-label" for="pizza-broto-price">🍕 Preço Broto (4 fatias) *</label>
								<div class="price-input-wrapper-modal">
									<span class="currency-tag">R$</span>
									<input 
										id="pizza-broto-price"
										type="text" 
										inputmode="decimal"
										class="form-input modal-price-input" 
										placeholder="30,00" 
										value={productForm.pizzaBrotoPrice} 
										on:input={(e) => handlePizzaPriceInput(e, 'broto')}
										on:blur={() => handlePizzaPriceBlur('broto')}
									/>
								</div>
								<small class="field-hint">Preço base da pizza individual</small>
							</div>

							<div class="form-row">
								<label class="field-label" for="pizza-grande-price">🍕 Preço Grande (8 fatias) *</label>
								<div class="price-input-wrapper-modal">
									<span class="currency-tag">R$</span>
									<input 
										id="pizza-grande-price"
										type="text" 
										inputmode="decimal"
										class="form-input modal-price-input" 
										placeholder="42,00" 
										value={productForm.pizzaGrandePrice} 
										on:input={(e) => handlePizzaPriceInput(e, 'grande')}
										on:blur={() => handlePizzaPriceBlur('grande')}
									/>
								</div>
								{#if pizzaSizesDiffText}
									<small class="field-hint text-diff-calc">{pizzaSizesDiffText}</small>
								{:else}
									<small class="field-hint">Preço da pizza família/grande</small>
								{/if}
							</div>
						</div>
					{/if}
				</div>

				<div class="form-row">
					<label class="field-label" for="product-desc-input">Descrição Detalhada dos Ingredientes</label>
					<textarea 
						id="product-desc-input"
						rows="2" 
						class="form-textarea" 
						placeholder="Ex: 2 carnes smash de 90g, queijo cheddar derretido, bacon fatiado crocante e maionese da casa no pão brioche." 
						bind:value={productForm.description}
					></textarea>
				</div>

				<!-- Seção: Controle de Estoque Simples -->
				<div class="stock-config-box">
					<div class="stock-toggle-row">
						<div class="stock-toggle-meta">
							<div class="stock-toggle-title">
								<Icon name="package" size={16} color="#FF6A00" />
								<span>Controlar estoque deste item?</span>
							</div>
							<p class="stock-toggle-subtext">Quando ativado, o item esgota e pausa automaticamente ao zerar as unidades.</p>
						</div>
						<label class="switch-control" for="product-track-stock-switch" title="Ativar ou desativar controle de estoque">
							<input
								id="product-track-stock-switch"
								type="checkbox"
								bind:checked={productForm.trackStock}
							/>
							<span class="slider-switch"></span>
						</label>
					</div>

					{#if productForm.trackStock}
						<div class="stock-quantity-block">
							<label class="field-label" for="product-stock-quantity-input">
								Quantidade disponível
							</label>
							<div class="stock-input-group">
								<input
									id="product-stock-quantity-input"
									type="number"
									min="0"
									step="1"
									class="form-input stock-qty-input"
									placeholder="Ex: 24"
									bind:value={productForm.stockQuantity}
									on:keydown={(e) => {
										if (['.', ',', 'e', 'E', '+', '-'].includes(e.key)) {
											e.preventDefault();
										}
									}}
									on:input={(e) => {
										let val = parseInt(e.target.value, 10);
										if (isNaN(val) || val < 0) val = 0;
										productForm.stockQuantity = val;
									}}
								/>
								<span class="stock-qty-unit">un.</span>
							</div>
							<small class="stock-qty-hint">Aceita somente 0 ou números inteiros positivos.</small>
						</div>
					{/if}
				</div>

				<!-- Seção 1: Complementos Reutilizáveis (Globais) -->
				<div class="global-complements-section">
					<div class="section-title-row">
						<div class="sec-title-group">
							<Icon name="sparkles" size={16} color="#6366F1" />
							<h4>Complementos Reutilizáveis</h4>
						</div>
						<span class="sub-tip">Grupos globais associados a este produto</span>
					</div>

					{#if complementGroups.length === 0}
						<div class="global-empty-tip">
							<p>Nenhum grupo global cadastrado ainda. Use a aba "Complementos Globais" para criar grupos como "Turbine seu Burger", molhos ou adicionais.</p>
						</div>
					{:else}
						<div class="global-groups-checklist">
							{#each complementGroups as g (g.id)}
								<label class="global-group-check-card {globalGroupIdsPending.includes(g.id) ? 'selected' : ''}">
									<input
										type="checkbox"
										class="global-checkbox"
										checked={globalGroupIdsPending.includes(g.id)}
										on:change={() => handleToggleGlobalGroup(g.id)}
									/>
									<div class="global-check-info">
										<div class="global-check-name-row">
											<span class="global-group-name">{g.name}</span>
											<span class="badge-mini {g.required === 1 ? 'badge-mini-req' : 'badge-mini-opt'}">
												{g.required === 1 ? 'Obrigatório' : 'Opcional'}
											</span>
											{#if g.active !== 1}
												<span class="badge-mini badge-mini-off">Inativo</span>
											{/if}
										</div>
										<span class="global-group-meta">
											{(g.items || []).length} {(g.items || []).length === 1 ? 'item' : 'itens'} · Máx {g.max_choice}
											{#if g.free_choices > 0} · {g.free_choices} grátis{/if}
										</span>
									</div>
								</label>
							{/each}
						</div>
					{/if}
				</div>

			</div>

			<div class="modal-footer">
				<button type="button" class="btn-cancel" on:click={handleClose} disabled={isSavingProduct}>Cancelar</button>
				<button type="button" class="btn-save" on:click={handleSave} disabled={isSavingProduct}>
					{isSavingProduct ? "Salvando..." : "Salvar Produto no Cardápio"}
				</button>
			</div>
		</div>
	</div>
{/if}

<style>
	.modal-overlay {
		position: fixed;
		inset: 0;
		background: rgba(15, 23, 42, 0.5);
		backdrop-filter: blur(4px);
		display: flex;
		align-items: center;
		justify-content: center;
		z-index: 1100;
		padding: 20px;
	}

	.modal-box {
		width: 520px;
		max-width: 100%;
		max-height: 90vh;
		background: #FFFFFF;
		border-radius: 16px;
		box-shadow: 0 20px 40px -10px rgba(0, 0, 0, 0.2);
		display: flex;
		flex-direction: column;
		overflow: hidden;
		animation: modalPop 0.18s cubic-bezier(0.16, 1, 0.3, 1);
	}

	@keyframes modalPop {
		from { opacity: 0; transform: scale(0.96) translateY(8px); }
		to { opacity: 1; transform: scale(1) translateY(0); }
	}

	.modal-box.modal-large {
		width: 760px;
	}

	.modal-header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 18px 24px;
		border-bottom: 1px solid #E2E8F0;
	}

	.modal-title-group {
		display: flex;
		align-items: center;
		gap: 10px;
	}

	.modal-badge-icon {
		width: 32px;
		height: 32px;
		border-radius: 8px;
		background: #FFF7ED;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.modal-header h3 {
		margin: 0;
		font-size: 17px;
		font-weight: 800;
		color: #0F172A;
	}

	.close-btn {
		background: transparent;
		border: none;
		cursor: pointer;
		color: #94A3B8;
		padding: 4px;
		display: flex;
		align-items: center;
		border-radius: 6px;
		transition: all 0.15s ease;
	}

	.close-btn:hover {
		background: #F1F5F9;
		color: #0F172A;
	}

	.modal-body {
		padding: 20px 24px;
		display: flex;
		flex-direction: column;
		gap: 16px;
	}

	.modal-scroll {
		overflow-y: auto;
	}

	.catalog-master-trigger-card {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 12px 16px;
		background: #FFF7ED;
		border: 1px solid #FFEDD5;
		border-radius: 12px;
		gap: 12px;
	}

	.catalog-trigger-left {
		display: flex;
		align-items: center;
		gap: 12px;
	}

	.catalog-trigger-icon {
		width: 36px;
		height: 36px;
		border-radius: 8px;
		background: #FFFFFF;
		border: 1px solid #FED7AA;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-shrink: 0;
	}

	.catalog-trigger-text strong {
		display: block;
		font-size: 13px;
		font-weight: 700;
		color: #0F172A;
	}

	.catalog-trigger-text span {
		font-size: 11px;
		color: #64748B;
	}

	.btn-open-catalog-master {
		display: inline-flex;
		align-items: center;
		gap: 6px;
		padding: 8px 14px;
		background: #FF6A00;
		color: #FFFFFF;
		font-size: 12px;
		font-weight: 700;
		border: none;
		border-radius: 8px;
		cursor: pointer;
		white-space: nowrap;
		box-shadow: 0 2px 4px rgba(255, 106, 0, 0.2);
		transition: all 0.15s ease;
	}

	.btn-open-catalog-master:hover {
		background: #E85A00;
		transform: translateY(-1px);
	}

	.catalog-prefilled-badge {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 8px 12px;
		background: #ECFDF5;
		border: 1px solid #A7F3D0;
		border-radius: 8px;
		font-size: 12px;
		color: #065F46;
	}

	.badge-content {
		display: flex;
		align-items: center;
		gap: 8px;
	}

	.btn-clear-origin {
		background: transparent;
		border: none;
		color: #059669;
		cursor: pointer;
		padding: 2px 4px;
		display: flex;
		align-items: center;
		border-radius: 4px;
	}

	.btn-clear-origin:hover {
		background: #D1FAE5;
	}

	.photo-upload-block {
		display: flex;
		flex-direction: column;
		gap: 6px;
	}

	.product-photo-card {
		display: flex;
		flex-direction: column;
		gap: 10px;
	}

	.prod-full-preview-box {
		position: relative;
		width: 100%;
		height: 180px;
		border-radius: 10px;
		overflow: hidden;
		border: 1px solid #E2E8F0;
	}

	.prod-full-preview-img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.prod-preview-controls {
		position: absolute;
		bottom: 10px;
		left: 10px;
		right: 10px;
		display: flex;
		align-items: center;
		justify-content: flex-end;
		gap: 8px;
	}

	.btn-overlay-bank, .btn-overlay-change, .btn-overlay-remove {
		padding: 6px 12px;
		border-radius: 6px;
		font-size: 11px;
		font-weight: 700;
		cursor: pointer;
		display: inline-flex;
		align-items: center;
		gap: 5px;
		border: none;
	}

	.btn-overlay-bank {
		background: rgba(15, 23, 42, 0.85);
		color: #FFFFFF;
		backdrop-filter: blur(4px);
	}

	.btn-overlay-change {
		background: rgba(255, 255, 255, 0.95);
		color: #0F172A;
		backdrop-filter: blur(4px);
	}

	.btn-overlay-remove {
		background: rgba(239, 68, 68, 0.9);
		color: #FFFFFF;
		backdrop-filter: blur(4px);
	}

	.product-photo-dropzone {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		padding: 20px;
		background: #F8FAFC;
		border: 2px dashed #CBD5E1;
		border-radius: 10px;
		cursor: pointer;
		text-align: center;
		gap: 4px;
		transition: all 0.15s ease;
	}

	.product-photo-dropzone:hover {
		border-color: #FF6A00;
		background: #FFF7ED;
	}

	.dropzone-svg-box {
		margin-bottom: 2px;
	}

	.photo-catalog-alt-row {
		display: flex;
		justify-content: center;
		margin-top: 4px;
	}

	.btn-search-catalog-photo {
		display: inline-flex;
		align-items: center;
		gap: 6px;
		padding: 7px 14px;
		background: #FFF7ED;
		border: 1px dashed #FF6A00;
		border-radius: 8px;
		color: #FF6A00;
		font-size: 12px;
		font-weight: 700;
		cursor: pointer;
		transition: all 0.15s ease;
	}

	.btn-search-catalog-photo:hover {
		background: #FFEDD5;
	}

	.fallback-url-row {
		display: flex;
		align-items: center;
		gap: 8px;
		font-size: 11px;
		color: #64748B;
	}

	.fallback-url-row input {
		flex: 1;
		padding: 6px 10px;
		font-size: 12px;
		border: 1px solid #CBD5E1;
		border-radius: 6px;
		color: #0F172A;
	}

	.form-row {
		display: flex;
		flex-direction: column;
		gap: 6px;
	}

	.form-grid-2 {
		display: grid;
		grid-template-columns: 1fr 1fr;
		gap: 14px;
	}

	.field-label {
		font-size: 12px;
		font-weight: 700;
		color: #334155;
	}

	.form-input, .form-textarea {
		width: 100%;
		padding: 9px 12px;
		background: #FFFFFF;
		border: 1px solid #CBD5E1;
		border-radius: 8px;
		font-size: 13px;
		color: #0F172A;
		box-sizing: border-box;
		font-family: inherit;
		transition: border-color 0.15s, box-shadow 0.15s;
	}

	.form-input:focus, .form-textarea:focus {
		outline: none;
		border-color: #FF6A00;
		box-shadow: 0 0 0 2px rgba(255, 106, 0, 0.15);
	}

	.form-input.input-error {
		border-color: #EF4444;
		background-color: #FEF2F2;
	}

	.field-error-hint {
		font-size: 11px;
		color: #DC2626;
		font-weight: 600;
	}

	.price-input-wrapper-modal {
		position: relative;
		display: flex;
		align-items: center;
		width: 100%;
	}

	.price-input-wrapper-modal .currency-tag {
		position: absolute;
		left: 12px;
		font-size: 13px;
		font-weight: 700;
		color: #94A3B8;
		pointer-events: none;
		user-select: none;
		z-index: 2;
	}

	.price-input-wrapper-modal .modal-price-input {
		width: 100%;
		padding-left: 36px !important;
		padding-right: 28px !important;
		font-weight: 600;
	}

	.stepper-buttons-group {
		position: absolute;
		right: 4px;
		top: 4px;
		bottom: 4px;
		width: 20px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		gap: 2px;
		z-index: 2;
	}

	.btn-step {
		flex: 1;
		display: flex;
		align-items: center;
		justify-content: center;
		background: #F1F5F9;
		border: 1px solid #CBD5E1;
		border-radius: 3px;
		color: #475569;
		cursor: pointer;
		padding: 0;
		transition: all 0.12s ease;
		user-select: none;
	}

	.btn-step:hover {
		background: #E2E8F0;
		color: #0F172A;
		border-color: #94A3B8;
	}

	/* Pizza Sizes Config */
	.pizza-sizes-config-box {
		margin-top: 14px;
		margin-bottom: 14px;
		padding: 14px 16px;
		background: #FFF7ED;
		border: 1px solid #FFEDD5;
		border-left: 4px solid #EA580C;
		border-radius: 10px;
	}

	.pizza-sizes-toggle-row {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 16px;
	}

	.pizza-sizes-toggle-meta {
		display: flex;
		flex-direction: column;
		gap: 3px;
	}

	.pizza-sizes-toggle-title {
		display: flex;
		align-items: center;
		gap: 8px;
		font-size: 13px;
		font-weight: 700;
		color: #9A3412;
	}

	.badge-pizza-sizes {
		display: inline-flex;
		align-items: center;
		padding: 2px 7px;
		background: #FED7AA;
		color: #C2410C;
		font-size: 10px;
		font-weight: 700;
		border-radius: 999px;
		text-transform: uppercase;
		letter-spacing: 0.5px;
	}

	.badge-auto-calc {
		font-size: 11px;
		font-weight: 600;
		color: #EA580C;
		margin-left: 6px;
	}

	.pizza-sizes-toggle-desc {
		font-size: 11px;
		color: #9A3412;
		margin: 0;
		opacity: 0.9;
		line-height: 1.4;
	}

	.pizza-sizes-inputs-grid {
		display: grid;
		grid-template-columns: 1fr 1fr;
		gap: 16px;
		margin-top: 14px;
		padding-top: 12px;
		border-top: 1px solid #FED7AA;
	}

	.text-diff-calc {
		color: #059669 !important;
		font-weight: 600 !important;
	}

	.field-hint {
		font-size: 11px;
		color: #64748B;
		margin-top: 2px;
	}

	/* Switch Control */
	.switch-control {
		position: relative;
		display: inline-block;
		width: 42px;
		height: 24px;
		flex-shrink: 0;
	}

	.switch-control input {
		opacity: 0;
		width: 0;
		height: 0;
	}

	.slider-switch {
		position: absolute;
		cursor: pointer;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: #CBD5E1;
		transition: .2s ease;
		border-radius: 24px;
	}

	.slider-switch:before {
		position: absolute;
		content: "";
		height: 18px;
		width: 18px;
		left: 3px;
		bottom: 3px;
		background-color: #FFFFFF;
		transition: .2s ease;
		border-radius: 50%;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
	}

	.switch-control input:checked + .slider-switch {
		background-color: #FF6A00;
	}

	.switch-control input:checked + .slider-switch:before {
		transform: translateX(18px);
	}

	/* Stock Config */
	.stock-config-box {
		margin-top: 14px;
		margin-bottom: 14px;
		padding: 14px 16px;
		background: #F8FAFC;
		border: 1px solid #E2E8F0;
		border-radius: 10px;
	}

	.stock-toggle-row {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 16px;
	}

	.stock-toggle-meta {
		display: flex;
		flex-direction: column;
		gap: 3px;
	}

	.stock-toggle-title {
		display: flex;
		align-items: center;
		gap: 8px;
		font-size: 13px;
		font-weight: 700;
		color: #0F172A;
	}

	.stock-toggle-subtext {
		font-size: 11px;
		color: #64748B;
		margin: 0;
		line-height: 1.4;
	}

	.stock-quantity-block {
		margin-top: 12px;
		padding-top: 12px;
		border-top: 1px solid #E2E8F0;
	}

	.stock-input-group {
		display: flex;
		align-items: center;
		gap: 8px;
		max-width: 160px;
		margin-top: 4px;
	}

	.stock-qty-input {
		text-align: right;
		font-weight: 700;
		font-size: 14px;
	}

	.stock-qty-unit {
		font-size: 12px;
		font-weight: 600;
		color: #64748B;
	}

	.stock-qty-hint {
		display: block;
		font-size: 11px;
		color: #94A3B8;
		margin-top: 4px;
	}

	/* Global Complements Section */
	.global-complements-section {
		margin-top: 18px;
		padding-top: 16px;
		border-top: 1px solid #E2E8F0;
	}

	.section-title-row {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 8px;
	}

	.sec-title-group {
		display: flex;
		align-items: center;
		gap: 6px;
	}

	.sec-title-group h4 {
		margin: 0;
		font-size: 14px;
		font-weight: 700;
		color: #0F172A;
	}

	.sub-tip {
		font-size: 11px;
		color: #64748B;
	}

	.global-empty-tip {
		background: #F8FAFC;
		border: 1px dashed #CBD5E1;
		border-radius: 8px;
		padding: 12px 16px;
		font-size: 12px;
		color: #64748B;
		margin-top: 8px;
	}

	.global-groups-checklist {
		display: grid;
		grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
		gap: 10px;
		margin-top: 10px;
	}

	.global-group-check-card {
		display: flex;
		align-items: flex-start;
		gap: 10px;
		padding: 10px 12px;
		border: 1px solid #E2E8F0;
		border-radius: 8px;
		background: #FFFFFF;
		cursor: pointer;
		transition: all 0.15s ease;
		user-select: none;
	}

	.global-group-check-card:hover {
		border-color: #CBD5E1;
		background: #F8FAFC;
	}

	.global-group-check-card.selected {
		border-color: #818CF8;
		background: #EEF2FF;
	}

	.global-checkbox {
		margin-top: 3px;
		accent-color: #4F46E5;
		cursor: pointer;
	}

	.global-check-info {
		display: flex;
		flex-direction: column;
		gap: 3px;
		min-width: 0;
	}

	.global-check-name-row {
		display: flex;
		align-items: center;
		gap: 6px;
		flex-wrap: wrap;
	}

	.global-group-name {
		font-size: 13px;
		font-weight: 600;
		color: #1E293B;
	}

	.badge-mini {
		font-size: 10px;
		font-weight: 600;
		padding: 1px 6px;
		border-radius: 4px;
	}

	.badge-mini-req {
		background: #FEE2E2;
		color: #DC2626;
	}

	.badge-mini-opt {
		background: #E0E7FF;
		color: #4F46E5;
	}

	.badge-mini-off {
		background: #F1F5F9;
		color: #94A3B8;
	}

	.global-group-meta {
		font-size: 11px;
		color: #64748B;
	}

	.modal-footer {
		display: flex;
		align-items: center;
		justify-content: flex-end;
		gap: 10px;
		padding: 16px 24px;
		border-top: 1px solid #E2E8F0;
		background: #F8FAFC;
	}

	.btn-cancel {
		padding: 9px 16px;
		background: #FFFFFF;
		border: 1px solid #CBD5E1;
		border-radius: 8px;
		font-size: 13px;
		font-weight: 600;
		color: #475569;
		cursor: pointer;
		transition: all 0.15s ease;
	}

	.btn-cancel:hover {
		background: #F1F5F9;
		color: #0F172A;
	}

	.btn-save {
		padding: 9px 20px;
		background: #FF6A00;
		border: 1px solid transparent;
		border-radius: 8px;
		font-size: 13px;
		font-weight: 700;
		color: #FFFFFF;
		cursor: pointer;
		box-shadow: 0 2px 4px rgba(255, 106, 0, 0.2);
		transition: all 0.15s ease;
	}

	.btn-save:hover:not(:disabled) {
		background: #E85A00;
		transform: translateY(-1px);
	}

	.btn-save:disabled {
		opacity: 0.6;
		cursor: not-allowed;
	}
</style>
